import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { useLocation } from 'react-router-dom';
import { userState } from '../../state';
import { trackPageView, trackEvent } from '../../utils/analytics';
import { config } from '../../config';
import { getParameterByName } from '../../utils/url';
import AuthProvider from '../../providers/auth.provider';
import { getSSOAccessTokenEBPortal } from '../../services/pcbff';

const liffId = config.liff_id.groupEB;

function GroupEB() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [user] = useRecoilState(userState);
  const liffState = decodeURIComponent(params.get('liff.state'));
  const source = liffState ? getParameterByName(liffState, 'source') : null;

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const response = await getSSOAccessTokenEBPortal({
      username: user.username,
      email: user.e_mail,
      mobile: user.otp_mobile_no,
    });
    let redirectUrl = config.groupEBUrl;

    if (response.token) {
      redirectUrl += `?prefill=${encodeURIComponent(response.token)}`;
    }

    trackPageView(source);
    trackEvent('Group Policy', 'Group Policy');

    return (window.location.href = redirectUrl);
  };

  return <div></div>;
}

const GroupEBWithAuth = props => (
  <AuthProvider {...props} liffId={liffId} allowGuest={true}>
    <GroupEB />
  </AuthProvider>
);

export default GroupEBWithAuth;
